import { createBrowserRouter } from "react-router-dom";
import { captureLabCheckoutHandoff } from "@/features/labs/labCheckoutStorage";
import { captureMembershipLinks } from "@/features/membership/membershipLinks";

// App is imported before main runs. Sanitize before React Router snapshots
// location as well as before analytics; auth redirects must not retain secrets.
export function createAppRouter(
  ...args: Parameters<typeof createBrowserRouter>
) {
  captureLabCheckoutHandoff();
  captureMembershipLinks();
  return createBrowserRouter(...args);
}
